import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const canvaEmptySplitApi = createApi({
  reducerPath: 'api/canva',
  baseQuery: axiosBaseQuery({
    baseUrl:
      process.env.REACT_APP_API_BASE_URL ||
      'https://stag.nurture.farm/api/agrocraft-artisian/',
  }),
  endpoints: () => ({}),
});
